import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';

const setInlineElementStyle = (elementId, propertyName, value, updateStrategy) => {
  const element = getLiveElement(elementId);
  instance.driver.setInlineElementStyle(element, propertyName, value, updateStrategy);
  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);

  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default setInlineElementStyle;
